import { Card, Divider, Flex, Stack, Text } from '@mantine/core';

interface GuideCardProps {
  definitions: {
    element: React.ReactNode;
    description: string;
  }[];
  isPostTag?: boolean;
  title: string;
}

export default function GuideCard({ definitions, isPostTag, title }: GuideCardProps) {
  return (
    <Card variant="outlined" mt="md">
      <Text variant="caption-md">{`${title} Definition`}</Text>
      <Divider mt="md" />
      <Stack>
        {definitions.map((definition, index) => (
          <Flex
            pt="md"
            // eslint-disable-next-line react/no-array-index-key
            key={`${title}-item-${index}`}
            styles={{
              root: {
                borderTop: index === 0 ? undefined : '1px dashed var(--border-secondary)',
              },
            }}
          >
            <Flex miw={isPostTag ? 136 : 100} mr="sm" align="center">
              {definition.element}
            </Flex>
            <Text variant="body-sm">{definition.description}</Text>
          </Flex>
        ))}
      </Stack>
    </Card>
  );
}
